import * as React from 'react';

import CreatorInfoWithChannels from 'components/creator-info-with-channels/CreatorInfoWithChannels';
import CostAttributionTaskCounter from '../cost-attribution-tile/counters/CostAttributionTaskCounter';

import { renderPrice } from 'utils/helper/price';
import { __t, applyTranslations } from 'utils/language';
import { prepareDataForMetricsChannelsBasicFromCreator } from 'utils/metrics';

import type { BudgetSplitCreatorResource, BudgetSplitResource } from 'modules/reporting/types/BudgetSplitResource.type';

import './cost-attribution-bulk-item.scss';

applyTranslations(require('./cost-attribution-bulk-item.i18n.json'));

type Props = {
  creator: BudgetSplitCreatorResource,
  budgetSplit: BudgetSplitResource
};

const CostAttributionBulkItem: React.FC<Props> = ({ creator, budgetSplit }: Props) => {
  const deliverables = budgetSplit.taskSplits
    .filter((entry) => entry.count > 0)
    .map(({ deliverableType, count }) => ({ deliverableType, count }));

  return (
    <div className="cost-attribution-bulk-item">
      <CreatorInfoWithChannels
        creatorProfile={{
          ...creator,
          influencerFirstName: creator.name
        }}
        metricExtractor={prepareDataForMetricsChannelsBasicFromCreator}
        includeRatio
      />
      <span>
        <span>{__t('cost_attribution_bulk_item.budget_label')}</span>
        <span>{renderPrice(budgetSplit.totalBudget)}</span>
      </span>
      <span className="cost-attribution-bulk-item__task-list">
        <span className="cost-attribution-bulk-item__task-label">
          {__t('cost_attribution_bulk_item.tasks_label')}
        </span>
        <CostAttributionTaskCounter deliverables={deliverables} />
      </span>
    </div>
  );
};

export default CostAttributionBulkItem;
